






























































import { Component, Vue } from "vue-property-decorator";
import axios from "@/api/AuthAPI/auth-request-api";

import { pics } from "@/config/host.config";

import UploadingImagesToServer from "@/components/app/images/uploading-images-to-server.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import WeatherSettings from "@/components/settings/weather/weather-settings.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    UploadingImagesToServer,
    ChangeDeliteButtons,
    InputSearch,
    WeatherSettings,
  },
})
export default class RootWeather extends Vue {
  folder = "Weather";
  paintings: Array<string> = [];
  search = "";

  get getPaintings(): Array<string> {
    const search = this.search && this.search.toLowerCase();
    if (!search) return this.paintings;

    return this.paintings.filter((picture) => {
      return picture.toLowerCase().indexOf(search.toLowerCase()) > -1;
    });
  }

  async getPictures(): Promise<void> {
    const url = pics.download;
    const config = { params: { path: this.folder } };

    const paintings = await axios.get(url, config);

    if (paintings.status === 200) {
      this.paintings =
        paintings.data == "Папка не найдена" || paintings.data == "Папка пуста"
          ? []
          : paintings.data;
    }
  }

  async deleteElement(id: string, type: boolean): Promise<void> {
    if (type || !id) return;
    const name = id;
    const path = this.folder;

    this.$deliteImage(name, path).then(() => {
      this.getPictures();
    });
  }

  mounted(): void {
    this.getPictures();
  }
}
